import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PureButton } from 'components/Styled';

class Hint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible
    };
  }

  render() {
    if (this.state.visible)
      return (
        <Tooltip
          placement="bottom"
          title={this.props.msg}
          overlayClassName={'hints'}
          alt="hint"
        >
          <PureButton noMargin>
            <FontAwesomeIcon icon="question-circle" />
          </PureButton>
        </Tooltip>
      );
    else return null;
  }
}

export default Hint;
